import EventApi from "../api/EventsApi";
import * as VideoConference from "video-conference";
import VoximplantDevicesManager from "./Providers/Voximplant/DevicesManager";
import AgoraDevicesManager from "./Providers/Agora/DevicesManager";

/**
 * Управление устрайствами ввода\вывода
 */
export default class DevicesManager {
    private devicesProvider: VideoConference.DevicesManagerInterface = new AgoraDevicesManager();

    /**
     * Изменить провайдера данных
     * @param provider
     */
    public changeProvider(provider: string): void
    {
        if (provider === 'voximplant' && !(this.devicesProvider instanceof VoximplantDevicesManager)) {
            this.devicesProvider = new VoximplantDevicesManager();
        }

        if (provider === 'agora' && !(this.devicesProvider instanceof AgoraDevicesManager)) {
            this.devicesProvider = new AgoraDevicesManager();
        }
    }

    public getProvider(): VideoConference.DevicesManagerInterface
    {
        return this.devicesProvider;
    }

    /**
     * Инициализация устройств
     */
    public async initDevices(): Promise<void>
    {
        this.devicesProvider.initDevices().then(() => {
            EventApi.triggerEvent(EventApi.DEVICES_READY);
        });
    }

    /**
     * Получить доступ к медиаустройствам
     */
    public async getLocalMedia(element: HTMLElement)
    {
        await this.devicesProvider.getLocalMedia(element);
    }

    /**
     * Изменение камеры
     */
    public async changeCamera(newCameraId: string): Promise<void>
    {
        await this.devicesProvider.changeCamera(newCameraId);
    }

    /**
     * Изменить микрофон
     */
    public async changeMicrophone(newMicrophoneId: string): Promise<void>
    {
        await this.devicesProvider.changeMicrophone(newMicrophoneId);
    }

    /**
     * Установить настройки звонка
     */
    public async setCallSettings(): Promise<void>
    {
        await this.devicesProvider.setCallSettings();
    }

    /**
     * Остановить показ
     */
    public stopLocalMedia(): void
    {
        this.devicesProvider.stopLocalMedia();
    }

    /**
     * Состояние камеры
     */
    public get cameraStatus(): boolean
    {
        return this.devicesProvider.getCameraStatus();
    }

    /**
     * Установить состояние камеры
     */
    public set cameraStatus(status: boolean)
    {
        this.devicesProvider.setCameraStatus(status);
    }

    /**
     * Состояние микрофона
     */
    public get microphoneStatus(): boolean
    {
        return this.devicesProvider.getMicrophoneStatus();
    }

    /**
     * Установить состояние микрофона
     */
    public set microphoneStatus(status: boolean)
    {
        this.devicesProvider.setMicrophoneStatus(status);
    }

    /**
     * Установить состояние аудио
     */
    public set audioStatus(status: boolean)
    {
        this.devicesProvider.setAudioStatus(status);
    }

    /**
     * id текущей камеры
     */
    public getCameraId(): string|null
    {
        return this.devicesProvider.getCameraId();
    }

    /**
     * id текущего микрофона
     */
    public getMicId(): string|null
    {
        return this.devicesProvider.getMicId();
    }

    /**
     * Список камер
     */
    public getCamerasList(): Array<VideoConference.MediaDeviceInfo>
    {
        return this.devicesProvider.getCameras();
    }

    /**
     * Список микрофонов
     */
    public getMicrophonesList(): Array<VideoConference.MediaDeviceInfo>
    {
        return this.devicesProvider.getMicrophones();
    }
}
